import { render } from "./StudFinderPrivacy.vue?vue&type=template&id=f1496906&scoped=true"
import script from "./StudFinderPrivacy.vue?vue&type=script&lang=js"
export * from "./StudFinderPrivacy.vue?vue&type=script&lang=js"

import "./StudFinderPrivacy.vue?vue&type=style&index=0&id=f1496906&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1496906"]])

export default __exports__